(function () {
  function lfpCloseDesktopMenus() {
    document.querySelectorAll('.nav-bar [data-type="menuitem"][aria-controls], .header__desktop-nav [data-type="menuitem"][aria-controls]').forEach(function (trigger) {
      trigger.setAttribute('aria-expanded', 'false');

      var targetId = trigger.getAttribute('aria-controls');
      if (!targetId) return;

      var target = document.getElementById(targetId);
      if (target) {
        target.setAttribute('aria-hidden', 'true');
      }
    });

    document.querySelectorAll('.is-dropdown-open, .nav-dropdown--glued, .nav-dropdown--inverse').forEach(function (el) {
      el.classList.remove('is-dropdown-open', 'nav-dropdown--glued', 'nav-dropdown--inverse');
    });
  }

  function lfpOpenDesktopMenu(trigger) {
    if (!trigger) return;

    var targetId = trigger.getAttribute('aria-controls');
    if (!targetId) return;

    var target = document.getElementById(targetId);
    if (!target) return;

    lfpCloseDesktopMenus();

    trigger.setAttribute('aria-expanded', 'true');
    target.setAttribute('aria-hidden', 'false');
  }

  function lfpBindDesktopNavFallback() {
    var triggers = document.querySelectorAll('.nav-bar [data-type="menuitem"][aria-controls], .header__desktop-nav [data-type="menuitem"][aria-controls]');

    triggers.forEach(function (trigger) {
  if (trigger.dataset.lfpNavBound === 'true') return;
  trigger.dataset.lfpNavBound = 'true';

  function openThisMenu() {
    if (window.innerWidth < 1000) return;

    var parentItem = trigger.parentNode;
    var parentMenu = trigger.closest('[data-type="menu"]');
    var targetId = trigger.getAttribute('aria-controls');
    var target = targetId ? document.getElementById(targetId) : null;

    if (!parentItem || !parentMenu || !target) return;

    parentMenu.querySelectorAll(':scope > .is-dropdown-open').forEach(function (openItem) {
      if (openItem !== parentItem) {
        openItem.classList.remove('is-dropdown-open');

        var openTrigger = openItem.querySelector(':scope > [data-type="menuitem"][aria-haspopup]');
        if (openTrigger) {
          openTrigger.setAttribute('aria-expanded', 'false');
        }

        var openMenu = openItem.querySelector(':scope > [data-type="menu"][aria-hidden]');
        if (openMenu) {
          openMenu.setAttribute('aria-hidden', 'true');
        }
      }
    });

    trigger.setAttribute('aria-expanded', 'true');
    parentItem.classList.add('is-dropdown-open');
    target.setAttribute('aria-hidden', 'false');
    parentMenu.classList.add('nav-dropdown--glued');
  }

  trigger.addEventListener('mouseover', function () {
    openThisMenu();
  });

  trigger.addEventListener('focusin', function () {
    openThisMenu();
  });

  trigger.addEventListener('click', function (event) {
    if (window.innerWidth < 1000) return;

    var expanded = trigger.getAttribute('aria-expanded') === 'true';
    var href = trigger.getAttribute('href');

    if (!expanded) {
      event.preventDefault();
      openThisMenu();
    } else if (href === '#') {
      event.preventDefault();
    }
  });

  var parentItem = trigger.parentNode;
  if (parentItem && parentItem.dataset.lfpNavLeaveBound !== 'true') {
    parentItem.dataset.lfpNavLeaveBound = 'true';

    parentItem.addEventListener('mouseout', function (event) {
      if (window.innerWidth < 1000) return;

      var related = event.relatedTarget;
      if (related && parentItem.contains(related)) {
        return;
      }

      parentItem.classList.remove('is-dropdown-open');

      var ownTrigger = parentItem.querySelector(':scope > [data-type="menuitem"][aria-haspopup]');
      if (ownTrigger) {
        ownTrigger.setAttribute('aria-expanded', 'false');
      }

      var ownMenu = parentItem.querySelector(':scope > [data-type="menu"][aria-hidden]');
      if (ownMenu) {
        ownMenu.setAttribute('aria-hidden', 'true');
      }
    });
  }
});

    document.querySelectorAll('.nav-bar, .header__desktop-nav, .nav-dropdown, .mega-menu').forEach(function (area) {
  if (area.dataset.lfpNavWrapBound === 'true') return;
  area.dataset.lfpNavWrapBound = 'true';

  area.addEventListener('mouseleave', function (event) {
    if (window.innerWidth < 1000) return;

    var related = event.relatedTarget;
    if (related && related.closest('.nav-bar, .header__desktop-nav, .nav-dropdown, .mega-menu')) {
      return;
    }

    lfpCloseDesktopMenus();
  });
});

    if (!document.documentElement.dataset.lfpNavDocBound) {
      document.documentElement.dataset.lfpNavDocBound = 'true';

      document.addEventListener('click', function (event) {
        var insideNav = event.target.closest('.nav-bar, .header__desktop-nav, .nav-dropdown, .mega-menu');
        if (!insideNav) {
          lfpCloseDesktopMenus();
        }
      });
    }
  }

  document.addEventListener('DOMContentLoaded', lfpBindDesktopNavFallback);
  window.addEventListener('pageshow', lfpBindDesktopNavFallback);

window.addEventListener('pageshow', function () {
  setTimeout(function () {
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  }, 50);

  setTimeout(function () {
    window.dispatchEvent(new Event('scroll'));
    window.dispatchEvent(new Event('resize'));
  }, 250);
});

  window.addEventListener('resize', function () {
    if (window.innerWidth < 1000) {
      lfpCloseDesktopMenus();
    }
  });

  setTimeout(lfpBindDesktopNavFallback, 500);
})();

(function () {
  function lfpForceStickyNavVisible() {
    if (window.innerWidth < 1000) return;

    var stickyHeader = document.querySelector('.shopify-section__header');
    var navBar = document.querySelector('.shopify-section__header .nav-bar');

    if (!stickyHeader || !navBar) return;

    var stickyStyles = window.getComputedStyle(stickyHeader);
    var navStyles = window.getComputedStyle(navBar);

    if (stickyStyles.position === 'sticky' && navStyles.display === 'none') {
      navBar.style.display = 'block';
    }
  }

  window.addEventListener('scroll', lfpForceStickyNavVisible, { passive: true });
  window.addEventListener('pageshow', function () {
    setTimeout(lfpForceStickyNavVisible, 50);
    setTimeout(lfpForceStickyNavVisible, 250);
  });
  window.addEventListener('load', lfpForceStickyNavVisible);
  document.addEventListener('DOMContentLoaded', lfpForceStickyNavVisible);
})();

(function () {
  function lfpRepairStickyNavOffset() {
    if (window.innerWidth < 1000) return;

    const sticky = document.querySelector('.shopify-section__header');
    const nav = document.querySelector('.nav-bar');

    if (!sticky || !nav) return;

    const stickyRect = sticky.getBoundingClientRect();
    const navRect = nav.getBoundingClientRect();

    nav.style.display = 'block';

    if (stickyRect.top === 0 && navRect.top < 0) {
      nav.style.position = 'relative';
      nav.style.top = `${Math.ceil(Math.abs(navRect.top))}px`;
    } else if (stickyRect.top === 0 && navRect.top >= 0) {
      nav.style.top = '';
    } else {
      nav.style.top = '';
    }
  }

  function lfpQueueStickyRepair() {
    requestAnimationFrame(lfpRepairStickyNavOffset);
  }

  document.addEventListener('DOMContentLoaded', lfpQueueStickyRepair);
  window.addEventListener('load', lfpQueueStickyRepair);
  window.addEventListener('pageshow', function () {
    setTimeout(lfpQueueStickyRepair, 50);
    setTimeout(lfpQueueStickyRepair, 250);
    setTimeout(lfpQueueStickyRepair, 750);
  });

  window.addEventListener('scroll', lfpQueueStickyRepair, { passive: true });
  window.addEventListener('resize', lfpQueueStickyRepair);
})();